var map = {
	"./CBSE-10.jpg": 1780,
	"./CBSE-12.jpg": 9939,
	"./CDS.jpg": 557,
	"./CLAT.jpg": 4500,
	"./CSIR.jpg": 1552,
	"./GATE-IES.jpg": 4646,
	"./IIT-JAM.jpg": 1546,
	"./JEE.jpg": 7000,
	"./KVPY.jpg": 434,
	"./NDA.jpg": 3162,
	"./NEET.jpg": 9675,
	"./NTSE.jpg": 9538,
	"./RRB.jpg": 523,
	"./SSC.jpg": 604,
	"./UPSE-CSE.jpg": 8576,
	"./class.jpg": 1877,
	"./doubt.jpg": 918,
	"./todo.jpg": 1117,
	"./tutor2.jpg": 8409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;